import { render, staticRenderFns } from "./QAdminAuditSubmenu.vue?vue&type=template&id=5c00f415&"
import script from "./QAdminAuditSubmenu.vue?vue&type=script&lang=js&"
export * from "./QAdminAuditSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports